<script>
import api from "@services/api";
import ExpedienteResumoBarChart from "./ExpedienteResumoBarChart";
import ExpandableTextLine from "vue-expandable-text-line";

// import Treeselect from "@riophae/vue-treeselect";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Combo from "./comboComp.vue";

export default {
  components: {
    ExpedienteResumoBarChart,
    ExpandableTextLine,
    Combo    
  },
  props: {
    exibeFiltros: {
      type: Boolean,
      default: true
    },    
    exibeGrafico: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    selectedConsultor: undefined,
    selectedProjetos: undefined,
    selectedBusca: "",
    loaded: false,
    showBuscaAvancada: false,
    consultorList: [],
    clienteList: [],
    contratoList:[ 'Contrato','Erre'],
    items: null,
    graficoData: null,
    hasItems: false,
    periodo: null,
    page: 1,
    totalRows: 1,
    size: 20,
    contratoId: null,
    consultorId: null
   
    
  }),
  watch: {},
  created() {
    let endDate = new Date();
    endDate.setHours(0, 0, 0, 0);

    let startDate = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
    startDate.setHours(0, 0, 0);

    if (this.filters["ExpedienteLista.endDate"]) {
      endDate = this.filters["ExpedienteLista.endDate"];
    }

    if (this.filters["ExpedienteLista.startDate"]) {
      startDate = this.filters["ExpedienteLista.startDate"];
    }

    this.dateRange = {
      startDate: startDate,
      endDate: endDate
    };

    if (this.exibeFiltros) {
      this.selectedConsultor =
        this.filters["ExpedienteLista.selectedConsultor"] ?? undefined;
      this.selectedProjetos =
        this.filters["ExpedienteLista.selectedProjetos"] ?? undefined;
      this.selectedBusca = this.filters["ExpedienteLista.selectedBusca"] ?? "";

      /* Mostrar busca avançada se houver algum critério de busca */
      if (
        this.selectedConsultor?.length > 0 ||
        this.selectedProjetos?.length > 0 ||
        this.selectedBusca != ""
      ) {
        this.showBuscaAvancada = true;
      }
    }

    // this.getData();
    this.iniciaData();
    this.getDataGrafico();
  },
  mounted() {
    this.getConsultorList();    
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    filters() {
      return this.$store.state.filter.filters;
    },
    ListClienteProjetoComp: function() {
      return this.lodash
        .chain(this.clienteList)
        .groupBy("nomeCliente")
        .map((value, key) => ({
          id: key,
          label: key,
          children: value.map(a => ({
            label: a.descricaoProjeto,
            clienteId: a.id,
            id: a.projetoId
          }))
        }))
        .value();
    },
    ListConsultorComp: function() {      
      return this.consultorList.map(c => ({ label: c.nome, id: c.id }));
    }
  },
  methods: {
    updateRange() {
      this.getData();
      this.getDataGrafico();
    },
    iniciaData(){
      this.getEstado();
      this.getData();
    },
    getEstado() {
      try {
        var estadoCombo = JSON.parse(localStorage.getItem("@saveStateCombo"));
        if (estadoCombo && estadoCombo.consultorId !== undefined) {
          this.consultorId = estadoCombo.consultorId;
        } else if (estadoCombo && estadoCombo.contratoId !== undefined) {
          this.contratoId = estadoCombo.contratoId;
        }
      } catch (e) {
        console.warn("Erro ao ler estado do combo:", e);
      }
    },
    groupBy(xs, key) {
      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    getData() {
      api
        .get(`api/Atendimento`, {
          params: {
            dataInicial: this.dateRange.startDate,
            dataFinal: this.dateRange.endDate,
            consultoresId: this.lodash.join(this.selectedConsultor, ","),
            projetosId: this.selectedProjetos,
            busca: this.selectedBusca,
            contratoId: this.contratoId,
            consultorId: this.consultorId,
            clienteId: this.clienteId
          }
        })
        .then(response => {
          this.items = this.groupBy(response.data["data"], "data");
          if (
            response.data["data"] !== null &&
            response.data["data"].length > 0
          ) {
            this.hasItems = true;
          } else {
            this.hasItems = false;
          }
          if (this.exibeFiltros) {
            this.$store.dispatch("filter/save", [
              {
                type: "ExpedienteLista.startDate",
                value: this.dateRange.startDate
              },
              {
                type: "ExpedienteLista.endDate",
                value: this.dateRange.endDate
              },
              {
                type: "ExpedienteLista.selectedConsultor",
                value: this.selectedConsultor
              },
              {
                type: "ExpedienteLista.selectedProjetos",
                value: this.selectedProjetos
              },
              {
                type: "ExpedienteLista.selectedBusca",
                value: this.selectedBusca
              }
            ]);
          } else {
            this.$store.dispatch("filter/save", [
              {
                type: "ExpedienteLista.startDate",
                value: this.dateRange.startDate
              },
              {
                type: "ExpedienteLista.endDate",
                value: this.dateRange.endDate
              },
              {
                type: "ExpedienteLista.selectedBusca",
                value: this.selectedBusca
              }
            ]);
          }
        });
    },
    getDataGrafico() {
      if (this.exibeGrafico) {
        this.loaded = false;
        api
          .get(`api/Atendimento/ResumoHorasTrabalhadasDia`, {
            params: {
              dataInicial: this.dateRange.startDate,
              dataFinal: this.dateRange.endDate,
              consultoresId: this.lodash.join(this.selectedConsultor, ","),
              projetosId: this.lodash.join(this.selectedProjetos, ","),
              busca: this.selectedBusca
            }
          })
          .then(response => {
            this.graficoData = response.data["data"];
            this.loaded = true;
          });
      }
    },
    callDetails(id) {
      this.$router.push(
        this.$route.query.redirectFrom || {
          path: `/Expediente/Detalhes/${id}`
        }
      );
    },
    callCopy(id) {
      this.$router.push(
        this.$route.query.redirectFrom || {
          path: `/Expediente/Copiar/${id}`
        }
      );
    },
    downloadPdf() {
      api
        .get(`api/Atendimento/Pdf`, {
          params: {
            dataInicial: this.dateRange.startDate,
            dataFinal: this.dateRange.endDate,
            projetosId: this.lodash.join(this.selectedProjetos, ","),
          }
        })
        .then(response => {
          this.$helper.callDownload(response.data["data"]);
        });
    },
    downloadCsv() {
      api
        .get(`api/Atendimento/Csv`, {
          params: {
            dataInicial: this.dateRange.startDate,
            dataFinal: this.dateRange.endDate
          }
        })
        .then(response => {
          this.$helper.callDownload(response.data["data"]);
        });
    },
    getConsultorList() {
      this.selectedFiltro = undefined;
      
      api.get(`Crud/Consultor/ConsultoresPorDatas`,{
         params: {           
            dataInicial: this.dateRange.startDate,
            dataFinal: this.dateRange.endDate            
          }
      }).then(response => {
        this.consultorList = response.data["data"];});
    },
    atualizaData(msg) {
      if (!msg) return;
      this.dateRange.startDate = msg.dataInicial;
      this.dateRange.endDate = msg.dataFinal;

      if (msg.selected && msg.selected.consultorId) {
        this.consultorId = msg.selected.consultorId;
      } else {
        this.consultorId = null;
      }

      if (!msg.selected) {
        this.contratoId = 0;
      }
      else{
        // this.contratoId = msg.selected.contratoId;
        // this.consultorId = msg.selected.consultorId;
      }
      
      this.clienteId = msg.clienteId;
      this.selectedProjetos = msg.projetoId;
      this.contratoId = msg.contratoId;

      this.getConsultorList();

      this.getData();
    },
    chartdata() {
      if (this.graficoData === null) {
        return {};
      } else {
        return {
          labels: this.graficoData.map(item =>
            this.$options.filters.formatField(item.data, "date")
          ),
          datasets: this.graficoData.map(function(item) {
            return {
              label: item.cliente,
              backgroundColor: item.cor,
              data: parseFloat(item.horasTrabalhadas).toFixed(2)
            };
          })
        };
      }
    },
    callNew() {
      this.$router.push(
        this.$route.query.redirectFrom || {
          path: `/Expediente/Novo`,
          props: {
            editable: true
          }
        }
      );
    }
  }
};
</script>
<template>
  
  <div>
    
    <div class="text-left row m-1">
      <div class="col-md-10 mt-1">
        
        <combo @AtualizarData="atualizaData" ></combo>       
      </div>     
      <div class="col-md-2 mt-4 text-right">
        <b-button
          class="btn btn-icon"
          v-if="user.perfil === 'Administrador' || user.perfil === 'Consultor'"
          variant="primary"
          v-on:click="callNew()"
        >
          Registrar atendimento
        </b-button>
      </div>
    </div>

    <div class="row mt-3 mb-3 ml-2" v-show="!hasItems">
      Não foram encontrados registros.
    </div>

    <div
      class="row mt-3 mb-3 ml-2"
      v-if="
        exibeGrafico &&
          (user.perfil === 'Administrador' || user.perfil === 'Consultor')
      "
    >
      <div class="col-md-12">
        <ExpedienteResumoBarChart v-if="loaded" :chartdata="chartdata()" />
      </div>
    </div>

    <div
      v-for="(expedientes, key) in items"
      :key="key"
      class="m-1 mt-2 row card expedientes-card"
    >
      <div class="card-body expedientes-lista">
        <div class="card-title">
          <h5>
            {{ key | formatField("extdate") }}
            <span class="float-right mr-2">
              {{ expedientes[0].duracaoDia | formatField("time") }}
            </span>
          </h5>
        </div>
        <div class="table-responsive">
          <table class="table mb-0">
            <thead></thead>
            <tbody>
              <tr v-for="expediente in expedientes" :key="expediente.id">
                <td>
                  <div class="expediente-tags">
                    <span
                      class="badge badge-pill badge-dark mr-1"
                      v-if="
                        user.perfil === 'Administrador' ||
                          user.perfil === 'Consultor'
                      "
                    >
                      {{ expediente.tarefa }}
                    </span>
                    <span
                      v-for="tag in expediente.tags.split(',')"
                      :key="tag"
                      class="badge badge-pill badge-primary mr-1"
                      >{{ tag }}</span
                    >
                  </div>
                  <div class="long-text">
                    <expandable-text-line
                      use-click
                      class="unprinting"
                      :duration="0"
                      v-text="expediente.descricao"
                    />
                    <div class="print-content">
                      {{ expediente.tarefa }}
                      {{ expediente.descricao }}
                    </div>
                    <div class="text-right mt-1 bold">
                      <cite title="Consultor">
                        {{ expediente.consultor }}
                      </cite>
                    </div>
                  </div>
                </td>
                <td width="120px;" class="text-center">
                  {{ expediente.periodo }}
                </td>
                <td width="80px;" class="text-center">
                  {{ expediente.duracaoExpediente | formatField("time") }}
                </td>
                <td
                  style="min-width=140px;"
                  v-if="
                    user.perfil === 'Administrador' ||
                      user.perfil === 'Consultor'
                  "
                >
                  <div class="float-right">
                    <b-button
                      class="btn btn-sm btn-icon"
                      variant="primary"
                      v-on:click="callDetails(expediente.id)"
                      ><i class="fe-more-horizontal"
                    /></b-button>
                    <b-button
                      class="btn btn-sm ml-1 btn-icon"
                      variant="primary"
                      v-on:click="callCopy(expediente.id)"
                      ><i class="fe-copy"
                    /></b-button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!-- end card-box -->
</template>
